'use client';

import useStore from '@/stores/useStore';
import { FC } from 'react';
import Link from './Link';

export interface PricingAddonsProps {
  title: string;
  subtitle: string;
  description: string;
  cta: {
    href: string;
    title: string;
    action: 'demo' | 'trial'
  };

  gridTitle: string;
  gridItems: {
    image: React.ReactNode;
    title: string;
    description: string;
    price: string;
    priceSubtitle: string;
  }[];

  /*
   * footerTitle: string;
   * footerDescription: string;
   * footerCta: {
   * href: string;
   * title: string;
   * };
   */
}

const PricingAddons: FC<PricingAddonsProps> = ({
  title,
  subtitle,
  description,
  cta,
  gridTitle,
  gridItems = [],
  /*
   * footerTitle,
   * footerDescription,
   * footerCta,
   */
}) => {
  const { setDemoModalOpen, setTrialModalOpen } = useStore();

  const modalActionHandler = (action) => {
    switch (action) {
      case 'trial':
        setTrialModalOpen(true);
        break;
      case 'demo':
        setDemoModalOpen(true);
        break;
      default:
        break;
    }
  };
  const header = (
    <div className="flex flex-col gap-3 text-center">
      <p className="text-14/14 uppercase tracking-wide">{subtitle}</p>
      <h3 className="text-30/35 md:text-56/65 font-500 tracking-tight">{title}</h3>
      <p className="text-17/24 md:text-20/28">{description}</p>
      <div className="flex justify-center items-center">
        {cta.href.length > 0 ? (
          <Link className="block button button-size-medium button-secondary-blue" href={cta.href}>
            {cta.title}
          </Link>
        ) : (
          <button className="block button button-size-medium button-secondary-blue"
            onClick={() => {
              modalActionHandler(cta.action);
            }}>
            {cta.title}
          </button>
        )}
      </div>
    </div>
  );

  const addonsGrid = (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-x-gutter-mobile md:gap-x-gutter-desktop gap-y-4">
      <div className="md:col-span-3">
        <p className="text-20/28 md:text-25/30 font-500">{gridTitle}</p>
      </div>
      {gridItems.map((item, index) => (
        <div key={`pricing-addon-${item.title?.replace(/\s/g, '-') ?? index}`} className="flex flex-col gap-3">
          {item.image}
          <div className="flex flex-col gap-1">
            <p className="text-20/28 md:text-25/30 font-500">{item.title}</p>
            <p className="text-17/24">{item.description}</p>
          </div>
          <p className="text-20/28 flex gap-half">
            <span className="font-500">{item.price}</span>
            <span>{item.priceSubtitle}</span>
          </p>
        </div>
      ))}
    </div>
  );

  const body = (
    <div className="bg-blue-200 text-blue-900 px-2 py-6 md:px-8 lg:pt-15 3xl:px-12 flex flex-col gap-6">
      {header}
      {addonsGrid}
    </div>
  );

  const footer = (
    <div>
    {/*
    * <div className="bg-blue-900 text-white px-2 py-6 pb-10 md:px-8 md:py-8 3xl:px-12">
      * <div className="grid md:grid-cols-2 gap-y-6 gap-x-gutter-mobile md:gap-x-gutter-desktop">
      */}
        {/*
        * <div className="flex flex-col gap-2">
          * <p className="text-25/30 md:text-25/30 font-500">{footerTitle}</p>
          * <p className="text-blue-200 text-17/24">{footerDescription}</p>
        * </div>
        */}
        {/*
        * <div className="flex flex-col justify-center items-center md:flex-row md:justify-end">
          * <Link
            * className="block button button-size-medium md:button-size-large button-primary-blue-light min-w-[240px]"
            * href={footerCta.href}
          * >
            * {footerCta.title}
          * </Link>
        * </div>
        */}
      {/*
      * </div>
      */}
    </div>
  );

  return (
    <div className="my-8 md:my-22 px-container-mobile md:px-container-desktop">
      <div className="mx-auto max-w-grid">
        <div className="md:-mx-8 3xl:-mx-12">
          <div className="rounded-20 md:rounded-40 overflow-hidden">
            {body}
            {footer}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingAddons;
